import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MENU_SECTIONS } from '../../data/menu.data';
import { MenuItemComponent } from '../menu-item/menu-item.component';

/**
 * Navegacion principal de la consola: secciones con encabezado + entradas.
 * No conoce el estado del sidebar; solo recibe si esta en modo rail.
 */
@Component({
  selector: 'app-side-menu',
  imports: [MenuItemComponent],
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideMenuComponent {
  /** Sidebar colapsado: solo iconos. */
  readonly rail = input(false);

  /** Se emite tras navegar, para que el drawer movil se cierre solo. */
  readonly navigated = output<void>();

  protected readonly sections = MENU_SECTIONS;
}
